import React, { Component } from "react";
import { Table } from "reactstrap";
import moment from "moment";
import { NepaliDatePicker } from "nepali-calander";

export default class GeneralAssessmentForm extends Component {
  render() {
    return (
      <div>
        <Table bordered striped className="tt-create-assessment-maintable mb-0">
          <tr style={{ background: `rgba(66, 118, 234, 0.3)` }}>
            <td style={{ verticalAlign: "middle" }}>
              <input
                type="checkbox"
                name="generalAssessmentCheck"
                checked={this.props.classroom.generalAssessmentChecked}
                onClick={(e) =>
                  this.props.handleGeneralAssessmentCheckbox(
                    e,
                    this.props.yearLevelIndex,
                    this.props.classroomIndex
                  )
                }
              />
            </td>
            <td style={{ verticalAlign: "middle" }}>
              <strong>General Assessment</strong>
            </td>
            <td>
              <label>
                <strong>From: </strong>
              </label>
              <br />
              <NepaliDatePicker
                type="input"
                calendarMode={localStorage.getItem('calendar-mode')}
                showToggle={true}
                showNationalHoliday={false}
                events={[]}
                onDateSelect={(date) => {
                  this.props.handleGeneralAssessmentDateChange(
                    {
                      target: { value: date.ad.date, name: "assessmentFromDate" },
                    },
                    this.props.yearLevelId,
                    this.props.classroomId,
                    "assessmentFromDate"
                  )
                }
                }
                value={
                  this.props.classroom.assessmentFromDate
                }
                minDate={moment(this.props.minStartDate).format("YYYY-MM-DD")}
              /> 
            </td>
            <td>
              <label>
                <strong>To: </strong>
              </label>
              <br />
              <NepaliDatePicker
                type="input"
                calendarMode={localStorage.getItem('calendar-mode')}
                showToggle={true}
                showNationalHoliday={false}
                events={[]}
                onDateSelect={(date) => {
                  this.props.handleGeneralAssessmentDateChange(
                    {
                      target: { value: date.ad.date, name: "assessmentToDate"},
                    },
                    this.props.yearLevelId,
                    this.props.classroomId,
                    "assessmentToDate"
                  )
                }
                }
                value={
                  this.props.classroom.assessmentToDate
                }
                minDate={moment(this.props.classroom.assessmentFromDate).format("YYYY-MM-DD")}
              /> 
            </td>
            <td>
              <label>
                <strong>Recording Date: </strong>
              </label>
              <br />
              <NepaliDatePicker
                type="input"
                calendarMode={localStorage.getItem('calendar-mode')}
                showToggle={true}
                showNationalHoliday={false}
                events={[]}
                onDateSelect={(date) => {
                  this.props.handleGeneralAssessmentDateChange(
                    {
                      target: { value: date.ad.date, name: "recordingDate" },
                    },
                    this.props.yearLevelId,
                    this.props.classroomId,
                    "recordingDate"
                  )
                }
                }
                value={
                  this.props.classroom.recordingDate
                }
                minDate={moment(new Date()).format("YYYY-MM-DD")}
              /> 
            </td>
            <td>
              <label>
                <strong>Deadline: </strong>
              </label>
              <br />
              <NepaliDatePicker
                type="input"
                calendarMode={localStorage.getItem('calendar-mode')}
                showToggle={true}
                showNationalHoliday={false}
                events={[]}
                onDateSelect={(date) => {
                  this.props.handleGeneralAssessmentDateChange(
                    {
                      target: { value: date.ad.date, name: "recordingDeadlineDate" },
                    },
                    this.props.yearLevelId,
                    this.props.classroomId,
                    "recordingDeadlineDate"
                  )
                }
                }
                value={
                  this.props.classroom.recordingDeadlineDate
                    ? this.props.classroom.recordingDeadlineDate
                    : ""
                }
                minDate={moment(this.props.classroom.recordingDate).format("YYYY-MM-DD")}
                disabled={
                  this.props.classroom.recordingDate &&
                    this.props.classroom.recordingDate !== ""
                    ? false
                    : true
                }
              /> 
            </td>
          </tr>
        </Table>
      </div>
    );
  }
}
